/**
 * Defines a user's security role, such as "Admin".
 */
export class SecurityRole {
    public id: string;
    public name: string;

    public clone(): SecurityRole {
        const clone: SecurityRole = new SecurityRole();
        clone.id = this.id;
        clone.name = this.name;
        return clone;
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): SecurityRole {
        const attrs: Object = json['attributes'];

        this.id = json['id'];
        this.name = attrs['name'];
        return this;
    }
}
